export const possessiveCase = noun =>
  noun.endsWith('s') ? `${noun}'` : `${noun}'s`

export const currency = value => `$${Number.parseFloat(value).toFixed(2)}`
